module.exports = __webpack_public_path__ + "img/26_103.e507033b.png";